import {
  Box,
  Button,
  Checkbox,
  Flex,
  HStack,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { BiSort } from "react-icons/bi";
import { filterAttribute } from "../../constants/constants";

export default function SortBy({
  sort,
  filterOptions,
  handleCheckboxChange,
  setApply,
  masterlistType,
  className,
  right="36%",
  zIndex="99",
  topAuctionTop
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  function getSortDisplay(filteroptions, sortoptions) {
    const sortByKey = filteroptions?.sortBy_v; // Get the sortBy_v key from filteroptions
    const sortOption = sortoptions?.find(option => option?.key === sortByKey); // Find the matching option
    return sortOption ? sortOption?.display : "Key not found"; // Return display value or fallback
}
  // Utility function to determine positioning styles
  return (
    <>
    <Stack display={{base:'none',md:'flex'}} gap={0} zIndex={zIndex} width="max-content">
      <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
        <PopoverTrigger>
          <HStack cursor="pointer" marginTop="0px!important" >
            <Button  fontSize={"14px"} fontWeight={"500"} gap={"5px"} colorPalette="teal" variant="solid">
            {filterAttribute.SORT_BY} {`| ${getSortDisplay(filterOptions, sort)}`}{" "} <BiSort />
      </Button>
          </HStack>
        </PopoverTrigger>
        <PopoverContent
          width="14rem"
          position="absolute"
          right="-74px"
          top="-10px"
          borderRadius="0"
          zIndex={99999}
        >
          <PopoverBody p="10px" zIndex="999!important">
            {sort?.map((it, index) => (
              <Flex key={index} borderBottom="1px" borderBottomColor="#f1f1f1">
                <Checkbox
                  borderColor="black"
                  _checked={{ "& .chakra-checkbox__control": { background: "black" } }}
                  iconColor="white"
                  cursor="pointer"
                  mr="5px"
                  isChecked={filterOptions.sortBy_v === it?.key}
                  onChange={() => {
                    handleCheckboxChange("sort", it?.key);
                    setApply(true);
                  }}
                />
                <Box p="1">
                  <Text cursor={"pointer"} onClick={() => {
                    handleCheckboxChange("sort", it?.key);
                    setApply(true);
                  }} fontSize="14px" fontWeight={"400"}>{it?.display}</Text>
                </Box>
              </Flex>
            ))}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Stack>

    {/* For mobile view */}

    {/* <Stack className={className} alignItems={"flex-end"} 
    position={masterlistType === "search"? "sticky":masterlistType === "film" ? "fixed" : masterlistType === "research-categories" ? "sticky" : "fixed"} 
    top={masterlistType==="film"?"183px":"112px"} 
    right={right}  
    display={{base:masterlistType==="research-categories"?"none":masterlistType==="search"?"none":masterlistType==="generic"?"none":"none",md:'none'}} 
    gap={0} zIndex={99} 
    width="auto" >
      <Popover isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
        <PopoverTrigger>
          <HStack p={"6px"} border={"1px solid #989898"} borderRadius={"5px"} cursor="pointer" marginTop="0px!important">
            <BiSort fontSize={"18px"} color="#353535" />
          </HStack>
        </PopoverTrigger>
        <PopoverContent
          width="14rem"
          position="relative"
          borderRadius="0"
          zIndex={99999}
        >
          <PopoverBody p="10px" zIndex="999!important">
            {sort?.map((it, index) => (
              <Flex key={index} borderBottom="1px" borderBottomColor="#f1f1f1">
                <Checkbox
                  borderColor="black"
                  _checked={{ "& .chakra-checkbox__control": { background: "black" } }}
                  iconColor="white"
                  cursor="pointer"
                  mr="5px"
                  isChecked={filterOptions.sortBy_v === it?.key}
                  onChange={() => {
                    handleCheckboxChange("sort", it?.key);
                    setApply(true);
                  }}
                />
                <Box p="1">
                  <Text fontSize="14px">{it?.display}</Text>
                </Box>
              </Flex>
            ))}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Stack> */}
    </>
  );
}
